import Image from "../../features/Image";
import images from "../images";
import variables from "../variables";
import home from "./home";
import {jumpTo} from "../../Utils";
import {currentPlayer} from "../people/people";
import conditions from "../conditions";
import Place from "./Place";
import menus from "./menus";
import missions from "../missions";
import Name from "../../features/Name";

const missionStyle = {color: "orange"};
const place = new Place("place", "place", "", "place")

const courier = new Place("courier", "Warehouse [Work]", "warehouse", "This is the largest warehouse in town of the company you work for. Here you can meet ordinary movers, other couriers and sometimes accidentally stumble upon people from the office, which is located at the top of the building.");
courier.addBeforeEnteringCallback(()=>(conditions.isDay02Start() && !variables.game.day02.droveToWork), "day02.goToWork");
courier.addDefaultLink("other.places.courier.courierJob", "game.courierJob", null, () => (!conditions.isEvening()));
courier.addDefaultLink("other.places.courier.courierGoHome", "game.courierGoHome", null, () => (conditions.isEvening()));
courier.addDefaultLink("other.places.courier.courierGoToOffice", "", ()=>{
    if (!missions.initCorruption_01.tasks.askAtOfficeAboutWife_01.started) jumpTo("game.courierJobOffice")
    else currentPlayer.goTo(places.courierOffice.id)
});
courier.getImage = function () {return <Image src={images.player.jobs[this.id][this.image]}/>};

const courierOffice = new Place("courierOffice", "Office", "office", "The usual small office space with a large warehouse.");
courierOffice.addDefaultLink("other.places.courierOffice.someGuy", "game.courierJobOfficeWorker", null, ()=>(missions.initCorruption_01.tasks.askAtOfficeAboutWife_01.isActive()), missionStyle);
courierOffice.addDefaultLink(<Name who="wife"/>, "", () => {currentPlayer.goTo(places.wifeMenu.id)}, ()=>(missions.initCorruption_01.finished && currentPlayer.isPlayer()), { color: "#e220d4" });
courierOffice.addDefaultLink(<Name who="officeWorker"/>, "game.courierJobOfficeWorker", null, ()=>(missions.initCorruption_01.tasks.askAtOfficeAboutWife_01.finished));
courierOffice.addDefaultLink("other.places.courierOffice.colleagues", "game.courierJobOfficeColleaguesAsWife", null, ()=>(currentPlayer.isWife()));
courierOffice.addDefaultLink("other.places.courierOffice.back", "", () => {currentPlayer.goTo(places.courier.id)}, ()=>(currentPlayer.isPlayer()));
courierOffice.getImage = function () {return <Image src={images.player.jobs.courier[this.image]}/>};

const table = new Place("table", "Computer Table", "computerTable", "A small work table with drawers and a computer.");
table.addDefaultLink("other.places.table.playComputer", "game.playComputer", null, ()=>(conditions.isDay() && currentPlayer.isPlayer()));
table.addDefaultLink("other.places.table.watchPorn", "game.watchPorn", null, ()=>(conditions.isDay()));
table.addDefaultLink("other.places.table.pillsMenu", "", () => {currentPlayer.goTo("pillsMenu")}, ()=>(currentPlayer.isPlayer()));
table.addDefaultLink("other.places.table.back", "", () => {currentPlayer.goTo(places.homeBedroom.id)});
table.getImage = function () {return <Image src={images.places[this.image]}/>};

const places = {
    place,
    courier,
    courierOffice,
    table,
    ...menus,
    ...home
};

places.getCurrent = function () {
    if (!this.current) {
        if (variables.player.where === "")
            return alert("ERROR. 'variables.player.where' is not defined");
        this.current = this[variables.player.where];
    }

    if (this.current.beforeEntering && this.current.beforeEntering.length !== 0) {
        for (const be of this.current.beforeEntering) {
            if (be.conditionCallBack())
                return jumpTo(be.passage)
        }
    }

    return (
        <div>
            {this.current.getCaption()}
            {this.current.getImage()}
            {this.current.getDescription()}
            <br/><br/>
            {this.current.getLinks()}
        </div>
    )
};

places.setCurrent = function (placeID = "") {
    if (!this[placeID]) return console.warn("ERROR. No such placeID in places");

    this.current = this[placeID];
    variables.player.where = this.current.id;
};

export default places;